import ConditionFilterActionRenderer from "./ConditionFilterActionRenderer.js";
import ConditionFilterModels from "./ConditionFilterModels.js";
export default {
  id: 'condition.filter.GroupScreen',
  layout: {
    sort: 'a.b'
  },
  handles: context => {
    const {
      clientProps,
      objectType
    } = context;
    const {
      delegate
    } = clientProps;
    const filterModel = ConditionFilterModels.getModelFor(delegate.type, objectType);
    return filterModel != null;
  },
  matches: {
    use: 'sortFilterBar',
    client: 'GroupScreen'
  },
  customComponent: ConditionFilterActionRenderer
};